import { Box } from "@mui/material";
import { ClockLoader } from "react-spinners";
import { ThemeProvider } from "@mui/material";
import Theme from "../utils/theme";
import { useSelector } from "react-redux";
import type { RootState } from "../store";
import { useMemo } from "react";

interface ILoadingProps {
    size?: string;
    color?: string;
}

const Loading: React.FC<ILoadingProps> = ({ size, color }) => {
    const themeState = useSelector((state: RootState) => state.theme);
    const theme = useMemo(() => Theme(themeState.mode), [themeState.mode]);
    const circleSize = size ?? "75px";

    return (
        <ThemeProvider theme={theme}>
            <Box
                sx={{
                    width: "100%",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    flexDirection: "column",
                }}
            >
                <ClockLoader size={circleSize} color={color ?? theme.palette.primary.main} />
            </Box>
        </ThemeProvider>
    );
};

export default Loading;
